export function getSlugForCourseDate(fullSlug: string) {
  const [slug, date] = fullSlug.split('/')
  return { slug, date }
}
